import { jsonApi } from './index';

const slidePhotosAPI = {
  get() {
    return jsonApi.findAll('slide_photo');
  },
};

export default slidePhotosAPI;
